angular.module('appMarketplace')
    .service('PasswordService', ['$http', 'UrlService', function ($http, UrlService) {
        var service = this;

        service.getUserInfo = function getUserInfo(token, successCallback, errorCallback) {
            var req = {
                method: 'GET',
                url: UrlService.createAbsoluteUrl('/rest/auth/token/' + token + '/userInfo')
            };

            $http(req).then(function successCallbackWrapper(response) {
                successCallback(response.data);
            }, function errorCallbackWrapper(response) {
                errorCallback(response.data)
            })
        };

        service.requestNewToken = function requestNewToken(token, successCallback, errorCallback) {
            var req = {
                method: 'POST',
                url: UrlService.createAbsoluteUrl('/rest/auth/token/' + token + '/renew')
            };

            $http(req).then(successCallback, function errorCallbackWrapper(response) {
                errorCallback(response.data)
            })
        };

        service.setPassword = function setPassword(token, newPassword, successCallback, errorCallback) {
            var req = {
                method: 'POST',
                url: UrlService.createAbsoluteUrl('/rest/auth/token/' + token + '/password'),
                data: {
                    password: newPassword
                }
            };

            $http(req).then(function successCallbackWrapper(response) {
                successCallback(response.data);
            }, function errorCallbackWrapper(response) {
                errorCallback(response.data)
            });
        };

        service.getValidPasswordLength = function (successCallback, errorCallback) {
            var req = {
                method: 'GET',
                url: UrlService.createAbsoluteUrl('/rest/passwordLength')
            };

            $http(req).then(function successCallbackWrapper(response) {
                successCallback(response.data)
            }, function errorCallbackWrapper(response) {
                errorCallback(response.data)
            })
        };

        service.updatePassword = function (oldPassword, newPassword, successCallback, errorCallback) {
            var req = {
                method: 'POST',
                url: UrlService.createAbsoluteUrl('/rest/currentUser/password'),
                data: {
                    oldPassword: oldPassword,
                    newPassword: newPassword
                }
            };

            $http(req).then(successCallback, function errorCallbackWrapper(response) {
                errorCallback(response.data)
            })
        };

        service.isDigit = function (char) {
            return !!parseInt(char);
        };

        service.validatePasswordCase = function (password) {
            var containsUpperCase = false,
                containsLowerCase = false,
                containsDigit = false;
            for (var i = 0; i < password.length; i++) {
                var currentChar = password[i];
                if (!service.isDigit(currentChar) && currentChar === currentChar.toLowerCase()) {
                    containsLowerCase = true;
                } else if (!service.isDigit(currentChar) && currentChar === currentChar.toUpperCase()) {
                    containsUpperCase = true;
                } else if (service.isDigit(currentChar)) {
                    containsDigit = true;
                }
            }
            return containsLowerCase && containsUpperCase && containsDigit;
        };

        service.validatePasswordRepeatedChars = function (password) {
            for (var i = 2; i < password.length; i++) {
                var currentChar = password[i];
                if ((currentChar === password[i - 1]) && (currentChar === password[i - 2])) {
                    return false;
                }
            }
            return true;
        };
    }]);


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/js/main/services/password-service.js
// module id = 84
// module chunks = 37